import { PlanningBlock } from '../pb-screen/models/planning-block/planning-block.interface';
import { PlanningBlockDetail } from './calculation-state.models';

/**
 * Pure function — maps planning blocks selected by the user into the slim
 * `PlanningBlockDetail` DTO that the optimistic UI layer stores alongside an operation.
 *
 * Extracting this as a standalone function (instead of a private method in each component)
 * gives us a single source of truth and makes it unit-testable without Angular.
 */
export function mapPbsToPlanningBlockDetails(pbs: PlanningBlock[]): PlanningBlockDetail[] {
  if (!pbs?.length) return [];
  return pbs.map(pb => ({
    // id: prefer .id, fall back to .orderLineId (used for TO-level PBs in planning-page)
    id: String((pb as any).id || (pb as any).orderLineId || ''),
    info: pb.info || '',
    orderNumber: pb.orderNumber || '',
    customerSearchName: pb.customerSearchName || (pb as any).customerName || '',
    containerOrTrailerSubType: (pb as any).containerOrTrailerSubType || '',
    trailerName: pb.trailer?.name || pb.trailerNo || (pb as any).trailerName || undefined,
    containerName: pb.container?.name || pb.containerNo || (pb as any).containerName || undefined,
    chassisName: pb.chassis?.name || pb.chassisNo || (pb as any).chassisName || undefined,
    containerType: (pb as any).containerType || undefined,
  }));
}
